/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenBlacklist
 */
export interface TokenBlacklist {
    /**
     * 
     * @type {string}
     * @memberof TokenBlacklist
     */
    refresh: string;
}

/**
 * Check if a given object implements the TokenBlacklist interface.
 */
export function instanceOfTokenBlacklist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;

    return isInstance;
}

export function TokenBlacklistFromJSON(json: any): TokenBlacklist {
    return TokenBlacklistFromJSONTyped(json, false);
}

export function TokenBlacklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenBlacklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refresh': json['refresh'],
    };
}

export function TokenBlacklistToJSON(value?: TokenBlacklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refresh': value.refresh,
    };
}

